var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8255 14.534C7.89862 15.47 8.8965 16.193 9.972 15.954L10.2656 15.889C10.535 15.8331 10.7826 15.7141 10.9828 15.5444C11.183 15.3747 11.3285 15.1605 11.4041 14.924C11.6516 14.108 12.0038 12.412 11.4739 10.414C11.6269 10.434 11.7945 10.451 11.9722 10.465C12.7744 10.53 13.8499 10.536 14.8027 10.254C15.3855 10.081 15.921 9.574 16.1528 8.982C16.2688 8.69543 16.3054 8.38822 16.2596 8.08639C16.2138 7.78456 16.0868 7.49698 15.8895 7.248C15.9547 7.13 16.0054 7.006 16.0448 6.886C16.1314 6.616 16.1719 6.318 16.1719 6.03C16.1719 5.74 16.1314 5.444 16.0448 5.173C16.0006 5.03349 15.9403 4.89843 15.8647 4.77C16.0549 4.383 15.9851 3.95 15.8614 3.621C15.7346 3.29648 15.5492 2.9925 15.3124 2.721C15.3731 2.568 15.3979 2.408 15.3979 2.256C15.3931 1.93527 15.295 1.6211 15.1132 1.344C14.7375 0.756999 13.9916 0.279999 12.9375 0.279999H9C8.31938 0.279999 7.79625 0.359999 7.35075 0.496999C6.96764 0.621684 6.60158 0.784379 6.2595 0.981999L6.2055 1.011C5.6385 1.319 5.08162 1.621 3.879 1.734C3.01725 1.815 2.25 2.434 2.25 3.279V7.279C2.25 8.13 3.02063 8.712 3.77663 8.895C4.73175 9.127 5.54737 9.682 6.17512 10.305C6.80512 10.931 7.20337 11.585 7.344 11.943C7.56787 12.518 7.7445 13.483 7.8255 14.534Z",
    fill: "#FFAB00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_92"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/ThumbsDown.d9982b3775c504e9b9e7c29550ac407a.svg";
export { ForwardRef as ReactComponent };